module.exports = __webpack_public_path__ + "static/img/0-2Trame.7e9df999.jpg";